import { Loading } from '@credit/tips';

export default Loading;
